<template>
  <form class="needs-validation" @submit.prevent="makePayment" novalidate>
    <section class="bg-white rounded mb-2 p-3 p-sm-4">
      <div class="row" v-if="!success">
        <div class="col-12 mb-3">
          <h1 class="h2">Payment Options</h1>
          <div role="alert" class="alert alert-warning" v-if="errors">
            <span>{{errors}}</span>
            <router-link
              v-if="profileIncomplete && theUserID"
              class="btn btn-primary btn-block-mob d-block d-sm-inline-block mt-3 mt-sm-0 ml-sm-3"
              :to="profileRoute"
            >Update Profile</router-link>
          </div>
        </div>
        <div class="col-12 mb-3" v-if="cartMembers.total <= 0">
          <div role="alert" class="alert alert-warning">
            A Family Membership is at least two adults, one juvenile and one mini or junior. As you have added additional mini, junior or juvenile membership/s, please use the <strong>Bank Transfer</strong>  option to check out. This will result in the membership being processed at no additional cost.
          </div>
        </div>
        <div class="col-12 form-group mb-4">
          <label class="sr-only">Payment Method</label>
          <div class="payment-options d-flex flex-wrap align-items-end">
            <div v-if="cartMembers.total" class="custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto">
              <label for="stripe" class="w-100 mb-2 ml-sm-n5 pl-2 d-flex align-items-center justify-content-center" style="height: 43px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.4 39.6" width="38" height="24" aria-labelledby="mastercard" class="ml-1"><title id="mastercard">Mastercard</title><circle cx="19.5" cy="19.7" r="19" fill="#ee0005"/><circle cx="43" cy="19.7" r="19" fill="#f9a000"/><path fill="#ff6300" d="M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 153" width="46" height="14" aria-labelledby="visa" class="ml-1"><title id="visa">Visa</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><path fill="#3c58bf" d="M185.3 149L210.9 5h40l-24.8 144z"/><path fill="#293688" d="M185.3 149L218.1 5h32.8l-24.8 144z"/><path fill="#3c58bf" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#293688" d="M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"/><path fill="#3c58bf" d="M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#293688" d="M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"/><path fill="#3c58bf" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"/><path fill="#293688" d="M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"/><path fill="#ffbc00" d="M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"/><path fill="#f7981d" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"/><path fill="#ed7c00" d="M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"/><g fill="#051244"><path d="M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"/></g></g></svg>
              </label>
              <input class="custom-control-input" type="radio" name="paymentMethod" id="stripe" value="stripe" checked="" v-model="paymentMethod">
              <label class="custom-control-label font-weight-normal text-nowrap" for="stripe">Credit Card</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto">
              <label for="claimVoucher" class="w-100 mb-2 ml-sm-n4 d-flex align-items-center justify-content-center" style="height: 43px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 12" width="43" height="30" aria-labelledby="claimoucher"><title id="claimvoucher">Claim Voucher</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"/><path fill="#231815" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="#231815" d="M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"/><g><path fill="#231815" d="M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"/></g></g></g></svg>
              </label>
              <input class="custom-control-input" type="radio" name="paymentMethod" id="claimVoucher" value="voucher" v-model="paymentMethod">
              <label class="custom-control-label font-weight-normal text-nowrap" for="claimVoucher">Claim Voucher</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto">
              <label for="bankTransfer" class="w-100 mb-2 ml-sm-n4 d-flex align-items-center justify-content-center" style="height: 43px;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" width="36" height="43" aria-labelledby="banktransfer"><title id="banktransfer">Bank Transfer</title><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"/><path fill="#231815" d="M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"/><g><path fill="#231815" d="M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"/></g></g></g></svg>
              </label>
              <input class="custom-control-input" type="radio" name="paymentMethod" id="bankTransfer" value="bank" v-model="paymentMethod">
              <label class="custom-control-label font-weight-normal text-nowrap" for="bankTransfer">Bank Transfer</label>
            </div>
          </div>
        </div>

        <VueSlideToggle :open="paymentMethod === 'voucher'" tag="div" :duration="500" class="col-12">
          <div class="alert alert-info">Paying by Claiming Voucher</div>
          <ol class="mb-5">
            <li class="mb-3">All memberships paid via voucher to be processed separately from other memberships.</li>
            <li class="mb-3">Email Voucher to aca@campdraft.com.au</li>
            <li class="mb-3">
              Play On Voucher for 17 year olds or Juvenile Riding for Adults points transfer balance to:</br></br>  
              Australian Campdraft Association Inc. </br> 
              BSB: 034-171 (Westpac) </br> 
              ACC: 171918 </br> 
              Reference: Juveniles Member Number </br> 
            </li>
            <li class="mb-3">Click <span style="color: var(--primary);">MAKE PAYMENT</span> for voucher to be processed.</li>
            <li class="mb-3">Once ACA has confirmed the voucher and received any due balance to the bank account the child’s profile will be made financial.</li>
            <li class="mb-3">Please allow 3 business days on receipt of voucher and bank payment for processing.</li>
          </ol>
        </VueSlideToggle>

        <VueSlideToggle :open="paymentMethod === 'bank'" tag="div" :duration="500" class="col-12">
          <div class="alert alert-info">You must now click ‘Make Payment’ to notify the ACA of your payment.</div>
          <ol class="mb-5">
            <li class="mb-3">
              Please make your bank transfer to:<br><br>
              Australian Campdraft Association Inc.<br>
              BSB: 034-171 (Westpac)<br>
              ACC: 171918<br>
            </li>
            <li class="mb-3">Ensure you include your Member Number <small class="border border-light px-2 rounded bg-lighter">{{theMemberNumber}}</small> & Surname as the transaction reference.</li>
            <li class="mb-3">You may now click ‘Make Payment’ to notify the ACA of your payment.</li>
            <li class="mb-3">Please allow 3 days for Bank Transfer and Claim Voucher payments to be processed.</li>
          </ol>
        </VueSlideToggle>

        <div class="col-12 d-flex justify-content-center justify-content-lg-end align-items-center flex-wrap text-right text-lg-left">
          <div class="d-flex flex-column flex-lg-row align-items-center align-items-lg-center w-100 justify-content-lg-end">
            <div class="mr-lg-3 text-center text-lg-right">
              <strong class="d-block d-lg-inline" v-if="cartMembers.total">
                Your total: ${{ totalDisplay }}
              </strong>
            </div>
            <button :class="['btn btn-block-mob mt-2 mt-lg-0', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit">
              {{ !processing ? 'Make Payment' : '' }}
              <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
            </button>
          </div>
        </div>

        <stripe-card-modal
          v-if="showCardModal"
          :amount="totalDisplay"
          @token="onCardToken"
          @close="closeCardModal"
        />
      </div>

      <div class="row" v-else>
        <div class="col-12">
          <h1 class="h2 mb-4">Thank You</h1>
          <div role="alert" :class="['alert alert-success', {'mb-3': !errors}]" v-if="success">{{success}}</div>
          <div role="alert" class="alert alert-warning mb-3" v-else-if="errors">{{errors}}</div>

          <h2 class="h3">Have an issue?</h2>
          <p>Your transaction is complete. If you experience some difficulties with payment processing or are not sure what the status of your payment is, please contact us on (07) 4622 3110.</p>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import axios from 'axios'
import { VueSlideToggle } from 'vue-slide-toggle'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import StripeCardModal from '@/components/StripeCardModal'

export default {
  name: 'Payment',
  components: {
    VueSlideToggle,
    StripeCardModal
  },
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        horses: [],
        users: [],
        total: 0
      }
    },
    type: String
  },
  mixins: [HANDLESUBMIT],
  data() {
    return {
      success: '',
      errors: '',
      paymentMethod: 'stripe',
      stripe: {
        email: this.getEmail()
      },
      env: process.env.NODE_ENV,
      userID: localStorage.userID,
      processing: false,
      profileIncomplete: false,
      showCardModal: false
    }
  },
  computed: {
    totalDisplay() {
      return Number(this.cartMembers.total || 0).toFixed(2)
    },
    theMemberNumber() {
      if (this.cartMembers.horses) {
        return this.cartMembers.horses[0].member_number
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.member_number
      }
      return this.cartMembers.users.filter(user => user.parent_id === null).length > 0 ? this.cartMembers.users.filter(user => user.primary === null)[0].member_number : this.cartMembers.users.length > 0 ? this.cartMembers.users[0].parent_member_number : null
    },
    theUserID() {
      if (this.cartMembers.horses) {
        return this.userID
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.id
      } else if (this.cartMembers.payer_user_id) {
        return this.cartMembers.payer_user_id
      } else if (this.cartMembers.users && this.cartMembers.users.length) {
        const user = this.cartMembers.users[0]
        if (user.attributes && user.attributes.user_id) {
          return user.attributes.user_id
        }
        return user.parent_id || user.id
      }
      return null
    },
    paymentReturnRoute() {
      return {
        name: this.$route.name,
        params: { ...this.$route.params }
      }
    },
    profileRoute() {
      if (localStorage.role === 'Admin' || localStorage.role === 'SuperAdmin') {
        return {
          name: 'Member Profile',
          params: {
            slug: String(this.theUserID),
            completePaymentProfile: true,
            returnTo: this.paymentReturnRoute
          },
          hash: '#details'
        }
      }

      return {
        name: 'My Profile',
        params: {
          tabSelect: 'details',
          completePaymentProfile: true,
          returnTo: this.paymentReturnRoute
        }
      }
    }
  },
  methods: {
    buildPaymentData(token, preflight) {
      const userId = this.theUserID
      if (!userId) {
        throw new Error('payer_user_id_missing')
      }

      return {
        user_id: userId,
        type: this.type,
        method: this.paymentMethod,
        total: this.cartMembers.total,
        items: this.cartMembers.items.map(item => item.id),
        token,
        preflight: Boolean(preflight),
        data: this.cartMembers.items.map((item, index) => {
          const tempObject = { ...item }
          if (this.type === 'registration' || this.type === 'rookie-nomination') {
            tempObject.horse_id = this.cartMembers.horses[index].id
          } else if (this.type === 'committee-affiliation') {
            tempObject.committee_id = this.cartMembers.committee.id
          } else {
            tempObject.userData = this.cartMembers.users[index]
          }
          delete tempObject.active
          delete tempObject.price
          delete tempObject.sku
          return tempObject
        })
      }
    },
    showPaymentError(error) {
      const responseData = error.response && error.response.data ? error.response.data : null
      this.success = ''
      this.profileIncomplete = Boolean(responseData && responseData.status === 'profile_incomplete')
      this.errors = responseData && responseData.message
        ? responseData.message
        : 'A server error occurred. Please try again later.'
    },
    async checkPaymentProfile() {
      try {
        const response = await axios.post(`${this.$api}/payment`, this.buildPaymentData(null, true))
        if (response.data.status === 'success') {
          this.profileIncomplete = false
          this.errors = ''
          if (response.data.email) {
            this.stripe.email = response.data.email
          }
          return true
        }

        this.success = ''
        this.profileIncomplete = response.data.status === 'profile_incomplete'
        this.errors = response.data.message || 'A server error occurred. Please try again later.'
      } catch (error) {
        if (error.message === 'payer_user_id_missing') {
          this.success = ''
          this.profileIncomplete = true
          this.errors = 'Your account details are incomplete. Please update your profile before making a payment.'
        } else {
          this.showPaymentError(error)
        }
      }
      return false
    },
    async addInvoice(token) {
      this.processing = true
      try {
        const data = this.buildPaymentData(token, false)
        const response = await axios.post(`${this.$api}/payment`, data)
        if (response.data.status === 'success') {
          this.resetCart()
          this.success = this.paymentMethod === 'voucher' || this.paymentMethod === 'bank' ? 'Thank you. Waiting for payment.' : 'Payment completed successfully.'
        } else if (response.data.status === 'error_payment_not_taken') {
          this.success = ''
          this.errors = 'An error occurred with the payment provider. You have not been charged. Please try again later.'
        } else if (response.data.status === 'card_error') {
          this.success = ''
          this.errors = response.data.message
        } else if (response.data.status === 'error') {
          this.success = ''
          this.errors = response.data.message
        } else {
          this.success = ''
          this.errors = response.data && response.data.message ? response.data.message : 'A server error occurred. Please try again later.'
        }
      } catch (error) {
        if (error.message === 'payer_user_id_missing') {
          this.success = ''
          this.profileIncomplete = true
          this.errors = 'Your account details are incomplete. Please update your profile before making a payment.'
        } else {
          this.showPaymentError(error)
        }
      } finally {
        this.processing = false
      }
    },
    getEmail() {
      if (typeof this.cartMembers.payer_email === 'string' && this.cartMembers.payer_email.trim()) {
        return this.cartMembers.payer_email.trim()
      }

      if (this.cartMembers.hasOwnProperty('users')) {
        const user = this.cartMembers.users.find(item =>
          item.attributes &&
          typeof item.attributes.email === 'string' &&
          item.attributes.email.trim()
        )
        return user ? user.attributes.email.trim() : ''
      } else if (this.cartMembers.hasOwnProperty('horses')) {
        return this.cartMembers.horses[0].member_email
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.email
      }
      return ''
    },
    makePayment() {
      setTimeout(async () => {
        if (this.formComplete && !this.processing) {
          this.processing = true
          const profileReady = await this.checkPaymentProfile()
          this.processing = false

          if (!profileReady) {
            return
          }

          switch (this.paymentMethod) {
            case 'stripe': {
              await this.stripePayment()
              break
            }
            case 'voucher': {
              this.done()
              break
            }
            case 'bank': {
              this.done()
              break
            }
            default: {
              break
            }
          }
        }
      }, 10)
    },
    resetCart() {
      /* Reset cart/selection data after payment */
      this.$store.commit('updateCartMembers', {})
      this.$store.commit('deselectAllRows')
    },
    stripePayment() {
      this.errors = ''
      this.processing = false
      this.showCardModal = true
    },
    onCardToken(token) {
      this.showCardModal = false
      this.done({ token: { ...token, email: this.stripe.email } })
    },
    closeCardModal() {
      this.showCardModal = false
      this.processing = false
    },
    done(token) {
      this.addInvoice(token)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Payment.vue